import { render } from "./New_UserRequestTab.vue?vue&type=template&id=dad18a0c"
import script from "./New_UserRequestTab.vue?vue&type=script&lang=js"
export * from "./New_UserRequestTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__